
import Vue from 'vue';
import Component from 'vue-class-component';
import { validators } from '@/utils/validations';
import { UserModel } from '@/models/user.model';
import { Emit, Ref } from 'vue-property-decorator';
import { HttpError } from '@/models/http.error';
import { featureKey as authFeatureKey } from '@/store/auth.store.module';
import { userModule, userState } from '@/utils/store-acessor';

@Component({})
export default class SignUpForm extends Vue {
  // @ts-ignore
  @Ref() registerForm: VForm;
  @userModule.Getter('user_id') userId!: number | null;
  errors: HttpError = new HttpError();
  readonly credentials = new UserModel(null, null);
  readonly rules = validators;
  termsOfUseCheck: boolean = false;
  privacyPolicyCheck: boolean = false;
  valid = false;
  showLoading = false;

  onBackToHome() {
    this.$router.push({ name: 'home' });
  }

  get canProceed(): boolean {
    return this.termsOfUseCheck && this.privacyPolicyCheck ? false : true;
  }

  openTermsAndPolicy(link?: string) {
    window.open(link, '_blank');
  }

  @Emit('onSuccess')
  welcome() {
    /** no-op */
  }

  async onRegister() {
    if (this.registerForm.validate()) {
      this.credentials.accept_terms = true;
      this.showLoading = true;
      try {
        const res = await userState.registerUser(this.credentials);
        this.$store.commit(`${authFeatureKey}/authenticationSuccess`, res);
        this.$router.replace('/profile/config');
      } catch (e) {
        this.errors = JSON.parse(JSON.stringify(e.response.data));
      } finally {
        this.showLoading = false;
      }
    }
  }

  errorMessages(): string[] {
    return HttpError.getErrorMessages(this.errors);
  }
}
